"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME = exports.rule = void 0;
const validator_1 = require("validator");
/**
 * {
 *   type: 'VALID_URL',
 * }
 */
const GenericValidator_1 = require("./GenericValidator");
exports.rule = (config) => new GenericValidator_1.GenericValidator(config, (value) => !!value &&
    validator_1.default.isURL(value, {
        require_tld: !!config.require_tld,
        require_host: !!config.require_host,
        require_protocol: config.require_protocol === 'true' ||
            config.require_protocol === undefined,
    }), 'Value %s is not a valid URL string');
exports.NAME = 'VALID_URL';
//# sourceMappingURL=ValidUrlRule.js.map